export default __webpack_public_path__ + "static/media/txt_entrance_03.0e9c20ce.svg";